module.exports = __webpack_public_path__ + "img/PC10.d2f049aa.png";